/**
   Copyright (c)2021 3Key Company s.r.o., All Rights Reserved

   It is strictly prohibited to distribute the source code,
   transpiled and compiled code or its parts without previous
   agreement of the 3Key Company board.
*/

import "./SaveAsDialog.css";

import React from "react";

import { SaveAsDialogProps, SaveAsDialogState } from "./SaveAsDialog.types";

import Dialog from "components/ThreeKey/Dialogs/Dialog";
import Switch from "components/ThreeKey/Switch";
import InputDropDown, { InputDropDownProps } from "components/ThreeKey/InputDropDown";
import Input from "components/ThreeKey/Input";


export default class SaveAsDialog extends React.Component<SaveAsDialogProps, SaveAsDialogState> {

   public constructor(props: SaveAsDialogProps) {

      super(props)

      this.state = {
         assetGroupName: "",
         assetGroupDescription: "",
         merge: false
      }

   }

   public render(): React.ReactNode {

      const saveDialogInputDropDownAttrs: InputDropDownProps = this.props.hasWritePermissions ?

         this.state.assetGroupName !== "" ? {
            valid: true,
            validText: ""
         } : {
            valid: false,
            invalidText: "Asset group name is mandatory"
         }

      : {
         invalidText: "Insufficient permissions",
         valid: false
      }

      const moSwitch = !this.props.assetGroups.find(ag => ag.startsWith(`${this.state.assetGroupName}|`)) ? <></> : (
         <div className="merge-overwrite">
            Overwrite
            &nbsp;&nbsp;&nbsp;
            <Switch
               disabled={this.props.validating.indexOf(this.state.assetGroupName) !== -1 || !this.props.hasWritePermissions[this.state.assetGroupName]}
               on={this.state.merge}
               onChange={(value) => { this.setState({ merge: value }) }}
            />
            &nbsp;&nbsp;&nbsp;
            Merge
         </div>
      );

      return (
         <Dialog
            closeOnOverlayMouseDown={false}
            closeOnEscape={true}
            onClose={this.props.onClose}
         >

            <div className="save-as-dialog">

               <div className="name">

                  <label htmlFor="assetGroupName">Asset group name:</label>
                  <br />
                  <InputDropDown
                     id="assetGroupName"
                     items={this.props.assetGroups.map(a => a.split("|")[0]).sort()}
                     value={this.state.assetGroupName}
                     onChange={this.onChange}
                     {...saveDialogInputDropDownAttrs}
                     isLoading={this.props.validating.indexOf(this.state.assetGroupName) >= 0}
                  />

                  <br />
                  <br />
                  <label htmlFor="assetGroupDescription">Asset group description</label>
                  <br />
                  <Input
                     autoComplete="off"
                     id="assetGroupDescription"
                     value={this.state.assetGroupDescription}
                     onChange={assetGroupDescription => this.setState({ assetGroupDescription: assetGroupDescription as string }) }
                  />


               </div>

               <div className="options">

                  {moSwitch}

               </div>

               <div>

                  <button
                     data-type="ok"
                     disabled={this.props.validating.indexOf(this.state.assetGroupName) >= 0 || !this.props.hasWritePermissions || this.state.assetGroupName === ""}
                     onClick={() => {this.props.onSave(this.state.assetGroupName, this.state.assetGroupDescription, this.state.merge)}}
                  >Save</button>

                  &nbsp;&nbsp;&nbsp;
                  <button data-type="cancel" onClick={this.props.onClose}>Cancel</button>

               </div>

            </div>

         </Dialog>

      )

   }

   private onChange = (value: string) => {

      const agnd = this.props.assetGroups.find(nd => nd.startsWith(`${value}|`));

      const assetGroupDescription = agnd ? agnd.split("|")[1] : this.state.assetGroupDescription;

      this.setState({
         assetGroupName: value,
         assetGroupDescription
      });

      this.props.onCheckExistsWithoutPermissions(value);

   }


}
